import Location from 'react-app-location';

export const ArchivedRequestsLocation = new Location('/requests/archived');
